import { DestinationEvent } from '@eventbrite/consumer-search.event-renderer';

export const filterUnactionableEvents = (events?: DestinationEvent[]) => {
    if (!events || !events.length) {
        return [];
    }

    return events.filter((event) => {
        const isOnSale = event.event_sales_status?.sales_status === 'on_sale';
        const isRecurrent = !!event.num_children && event.num_children > 1;
        return isOnSale || isRecurrent;
    });
};
